// ======================================================================
// File Name       : ArchivementDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import ArchivementDetail from '../../components/archivement/ArchivementDetail';
import { getReportOperationList } from '../../actions/archivement/ArchivementAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants/index';
import * as ReportActions from '../../actions/ReportOperationAction';
import ModalConductor from '../../components/modal/ModalConductor';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ArchivementDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportHistorySortType: -1,
      ascendingDescendingSort: 0,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
    };

    this.onSearchData = this.onSearchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    this.onSearchData();
  }

  componentWillReceiveProps(nextProps) {
    const { archivement, match } = nextProps;
    const { userList, userDetailInfo, recordNum, reportList } = archivement;
    const userDetail = $.grep(userList, e => e.userSecernId === match.params.id);
    if (userDetail.length > 0) {
      this.setState({
        userInfo: userDetail[0],
      });
    }
    this.setState({
      reportList,
      userDetailInfo,
      recordNum,
    });
  }

  onSearchData() {
    this.setState(
      {
        startPosition: 0,
      },
      () => {
        this.getReportOperationList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  getReportOperationList(selectTargetData) {
    const { match, archivement } = this.props;
    const { reportApprovalDateFrom, reportApprovalDateTo } = archivement;
    const param = {
      selectTargetData,
      searchInfo: {
        checkerUserList: undefined,
        reportApprovalDateFrom,
        reportApprovalDateTo,
        ascendingDescendingSort: this.state.ascendingDescendingSort,
        reportHistorySortType:
          this.state.reportHistorySortType < 0 ? undefined : this.state.reportHistorySortType,
        startPosition: this.state.startPosition,
        returnMaxNum: this.state.returnMaxNum,
      },
    };
    if (match.params.id) {
      param.searchInfo.checkerUserList = [match.params.id];
    }
    this.props.dispatch(getReportOperationList(param, match.params.id));
  }

  getStartEndData(startPosition) {
    this.setState(
      {
        startPosition,
      },
      () => {
        this.getReportOperationList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  handleSortState(row) {
    this.setState(
      {
        reportHistorySortType: row.sortBy,
        ascendingDescendingSort: row.sortState,
      },
      () => {
        this.getReportOperationList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  handleShowModal(index) {
    const { reportList } = this.state;
    this.props.dispatch(ReportActions.openReportDialog(reportList[index]));
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { hoverIndex } = this.state;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SCORING_ARCHIVEMENT_LIST}
          text="添削者別実績に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="添削者別実績情報の詳細"/>
        <ArchivementDetail
          userInfo={this.state.userInfo}
          userDetailInfo={this.state.userDetailInfo}
          recordNum={this.state.recordNum ? this.state.recordNum : 0}
          reportListInfo={this.state.reportList}
          archivement={this.state.archivement}
          startPosition={this.state.startPosition}
          getStartEndData={this.getStartEndData}
          handleSortState={this.handleSortState}
          onShowDetail={this.handleShowModal}
          dataSort={this.state}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <ModalConductor onCloseScoringReportDialog={this.onSearchData} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { archivement } = state;
  return {
    archivement,
  };
};

export default connect(mapStateToProps)(ArchivementDetailContainer);
